<script setup>

import { computed, inject, ref } from 'vue';
import Icon from '../Icon.vue';

import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firestore';
import { renderDate } from '@/payments/billingUtils';

const {extended} = defineProps(['extended'])

const userInfo = inject('userInfo')

const billingRef = doc(db, 'billing', userInfo.uid);


const billing = ref(null);
const credits = computed(() => {

  if (!billing.value) {
    return 0
  }

  let credits = billing.value.credits || 0;
  if (credits < 0) {
    credits = 0
  }  
  if (billing.value.subscription?.status === 'active') {
    let subscrCredits = billing.value.subscription?.credits || 0
    if (subscrCredits < 0) {
      subscrCredits = 0
    }
    credits += subscrCredits
  }
  return credits * 100;
})

const unsubscribe = onSnapshot(billingRef, (snap) => {
  if (snap.exists()) {    
    billing.value = snap.data()
  } else {
    billing.value = undefined;
  }
});

</script>

<template>
  <div class="flex items-center gap-1 cursor-pointer">
    <Icon 
      name="game-icons--two-coins" 
      :size="20" class="starring starred" style="margin-left: 5px"    
    />    
    
    {{ credits.toFixed(1) }}

    <span v-if="extended && !billing?.subscription">trial</span>
    <span v-if="extended && billing?.subscription && billing.subscription.status !== 'canceled' ">valid to {{ renderDate(billing.subscription.billingPeriod) }}</span>
    <span v-if="extended && billing?.subscription && billing.subscription.status === 'canceled' ">no active subscription</span>

  </div>
</template>


